module.exports = __webpack_public_path__ + "img/logowhite.ae2c65cd.png";